import { FC, memo } from 'react'

import styles from './navbar-helper.module.scss'
import Image from 'next/image'
import { STATIC_URL } from 'constants/data'

const imgArrow = `${STATIC_URL}/navbar/img_blue_arrow.svg`
const iconClose = `${STATIC_URL}/navbar/icon_close.svg`

interface INavbarHelper {
  closeHelper: () => void
}

const NavbarHelper: FC<INavbarHelper> = ({ closeHelper }) => {
  const closeHandle = () => {
    closeHelper()
  }
  return (
    <div className={styles.popupWrapper}>
      <div className={styles.bgPopup} onClick={closeHandle}></div>
      <div className={styles.helperWrapper}>
        <div className={styles.helperContent}>
          <div className={styles.helperTitle}>Попробуйте новое меню!</div>
          <p className={styles.helperTxt}>
            Теперь перемещение между разделами Medpoint стало удобнее и быстрее 😊
          </p>
          <button onClick={closeHandle}>
            <Image
              src={iconClose}
              alt={'Стрелка'}
              width={16}
              height={16}
              className={styles.btnClose}
            ></Image>
          </button>
          <Image
            src={imgArrow}
            alt={'Стрелка'}
            width={134}
            height={105}
            className={styles.blueArrow}
          ></Image>
        </div>
      </div>
    </div>
  )
}
export default memo(NavbarHelper)
